<template>
  <BaseDialog
    v-model="openDriverForm"
    :title="`${editMode ? 'Edit' : 'Add'} Driver`"
    width="80vh"
    @closeDialog="resetForm()"
  >
    <template #dialogContent>
      <v-form
        v-model="isValid"
        ref="driverForm"
        id="driverForm"
        name="driverForm"
      >
        <v-row>
          <v-col cols="6">
            <BaseTextInput
              id="first_name"
              name="first_name"
              v-model="driverDetails.first_name"
              :required="true"
              label="First Name"
              :error-messages="
                formErrors && formErrors.first_name ? formErrors.first_name : ''
              "
              @input="
                formErrors && formErrors.first_name
                  ? delete formErrors.first_name
                  : ''
              "
            ></BaseTextInput>
          </v-col>
          <v-col cols="6">
            <BaseTextInput
              id="last_name"
              name="last_name"
              v-model="driverDetails.last_name"
              :required="true"
              label="Last Name"
              :error-messages="
                formErrors && formErrors.last_name ? formErrors.last_name : ''
              "
              @input="
                formErrors && formErrors.last_name
                  ? delete formErrors.last_name
                  : ''
              "
            ></BaseTextInput>
          </v-col>

          <v-col cols="6">
            <BaseTextInput
              id="username"
              name="username"
              v-model="driverDetails.username"
              :required="true"
              label="Username"
              :error-messages="
                formErrors && formErrors.username ? formErrors.username : ''
              "
              @input="
                formErrors && formErrors.username
                  ? delete formErrors.username
                  : ''
              "
            ></BaseTextInput>
          </v-col>
          <v-col cols="6">
            <BasePasswordInput
              id="password"
              name="password"
              label="Password"
              :required="!editMode"
              v-model="driverDetails.password"
              :error-messages="
                formErrors && formErrors.password ? formErrors.password : ''
              "
              @input="
                formErrors && formErrors.password
                  ? delete formErrors.password
                  : ''
              "
            ></BasePasswordInput>
          </v-col>
          <v-col cols="6">
            <BasePasswordInput
              id="confirm_password"
              name="confirm_password"
              label="Confirm Password"
              :required="!editMode"
              v-model="driverDetails.confirm_password"
              :error-messages="
                formErrors && formErrors.confirm_password
                  ? formErrors.confirm_password
                  : ''
              "
              @input="
                formErrors && formErrors.confirm_password
                  ? delete formErrors.confirm_password
                  : ''
              "
            ></BasePasswordInput>
          </v-col>
          <v-col cols="6">
            <!-- <BasePhoneInput
              id="contact_number"
              name="contact_number"
              v-model="driverDetails.contact_number"
              :required="true"
              label="Contact No."
              :error-messages="
                formErrors && formErrors.contact_number
                  ? formErrors.contact_number
                  : ''
              "
              @input="
                formErrors && formErrors.contact_number
                  ? delete formErrors.contact_number
                  : ''
              "
            ></BasePhoneInput> -->
            <v-text-field
              outlined
              class="background-white rounded-lg remove-number-spinners"
              type="number"
              min="0"
              step="01"
              hide-details="auto"
              dense
              :required="true"
              label="Contact Number *"
              :error-messages="
                formErrors && formErrors.contact_number
                  ? formErrors.contact_number
                  : ''
              "
              v-model="driverDetails.contact_number"
              @input="
                formErrors && formErrors.contact_number
                  ? delete formErrors.contact_number
                  : ''
              "
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <BaseSelect
              id="project"
              name="project"
              v-model="driverDetails.project"
              :required="true"
              label="Select Project *"
              :itemsList="projectList"
              itemText="name"
              itemValue="value"
              :error-messages="
                formErrors && formErrors.project ? formErrors.project : ''
              "
              :rules="[(val) => !!val || 'Project is required']"
              @change="
                formErrors && formErrors.project
                  ? delete formErrors.project
                  : '',
                  getVehicleList({ project_id: driverDetails.project })
              "
            ></BaseSelect>
          </v-col>
          <v-col cols="6">
            <BaseSelect
              id="vehicle_assigned"
              name="vehicle_assigned"
              v-model="driverDetails.vehicle_assigned"
              label="Assign Vehicle"
              :error-messages="
                formErrors && formErrors.vehicle_assigned
                  ? formErrors.vehicle_assigned
                  : ''
              "
              @change="
                formErrors && formErrors.vehicle_assigned
                  ? delete formErrors.vehicle_assigned
                  : ''
              "
              :itemsList="vehicleList"
              itemText="name"
              itemValue="value"
            ></BaseSelect>
          </v-col>

          <v-col cols="6">
            <!-- <BaseTimeInput
              id="shift_start"
              name="shift_start"
              v-model="driverDetails.shift_start"
              :required="true"
              label="Shift Start Time"
              :error-messages="
                formErrors && formErrors.shift_start
                  ? formErrors.shift_start
                  : ''
              "
              @input="
                formErrors && formErrors.shift_start
                  ? delete formErrors.shift_start
                  : ''
              "
            ></BaseTimeInput> -->
            <v-text-field
              label="Shift Start Time *"
              outlined
              dense
              type="time"
              class="background-white rounded-lg"
              hide-details="auto"
              id="shift_start"
              name="shift_start"
              :error-messages="
                formErrors && formErrors.shift_start
                  ? formErrors.shift_start
                  : ''
              "
              @input="
                formErrors && formErrors.shift_start
                  ? delete formErrors.shift_start
                  : ''
              "
              v-model="driverDetails.shift_start"
              :rules="[(v) => !!v || 'Shift Start Time is required']"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <!-- <BaseTimeInput
              id="shift_end"
              name="shift_end"
              v-model="driverDetails.shift_end"
              :required="true"
              label="Shift End Time"
              :error-messages="
                formErrors && formErrors.shift_end ? formErrors.shift_end : ''
              "
              @input="
                formErrors && formErrors.shift_end
                  ? delete formErrors.shift_end
                  : ''
              "
            ></BaseTimeInput> -->
            <v-text-field
              label="Shift End Time *"
              outlined
              dense
              type="time"
              class="background-white rounded-lg"
              hide-details="auto"
              id="shift_end"
              name="shift_end"
              :error-messages="
                formErrors && formErrors.shift_end ? formErrors.shift_end : ''
              "
              @input="
                formErrors && formErrors.shift_end
                  ? delete formErrors.shift_end
                  : ''
              "
              v-model="driverDetails.shift_end"
              :rules="[(v) => !!v || 'Shift End Time is required']"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </template>

    <template #actions>
      <BaseSecondaryButton
        v-if="!editMode"
        id="driverResetBtn"
        customClass="rounded-lg"
        small
        >Reset</BaseSecondaryButton
      >
      <BaseButton
        :disabled="!isValid"
        id="driverSubmitBtn"
        customClass="rounded-lg"
        small
        @click="submitForm()"
        >Submit</BaseButton
      >
    </template>
  </BaseDialog>
</template>

<script>
import { bus } from "@/main";
export default {
  props: {
    value: {
      type: Boolean,
    },
    editMode: {
      type: Boolean,
    },
  },
  data() {
    return {
      isValid: true,
      projectList: [],
      driverDetails: {},
      formErrors: {},
      vehicleList: [],
    };
  },
  watch: {
    openDriverForm(val) {
      if (val) {
        this.getProjectsList();
        this.getVehicleList();
      }
    },
  },
  computed: {
    openDriverForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    getDriverObject(id = null) {
      this.$api.driver
        .getDriverObject(id)
        .then((res) => {
          this.driverDetails = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getProjectsList(params = {}) {
      params = {
        ...params,
        limit: "all",
      };
      this.$api.projects.getProjectList(params).then((res) => {
        this.projectList = res.data.map((obj) => {
          return {
            name: obj.project_name,
            value: obj.project_id,
          };
        });
      });
    },

    getVehicleList(params = {}) {
      params = {
        ...params,
        limit: "all",
      };
      this.$api.vehicle.getVehicleList(params).then((res) => {
        this.vehicleList = res.data.map((obj) => {
          return {
            name: obj.vehicle_number,
            value: obj.vehicle_number,
          };
        });
      });
    },

    submitForm() {
      let data = { ...this.driverDetails };

      if (!this.editMode) {
        this.$api.driver
          .createDriver(data)
          .then(() => {
            bus.$emit("showLoader", false);
            bus.$emit("showToastMessage", {
              message: "Driver created!",
              color: "success",
            });
            this.resetForm();
            this.openDriverForm = false;
            this.$emit("refreshList");
          })
          .catch((err) => {
            console.error(err);
            bus.$emit("showLoader", false);
            this.formErrors = err.data;
          });
      } else {
        this.$api.driver
          .updateDriverObject({
            id: this.driverDetails.id,
            data: data,
          })
          .then(() => {
            bus.$emit("showToastMessage", {
              message: "Driver information updated!",
              color: "success",
            });
            this.resetForm();
            this.openDriverForm = false;
            this.$emit("refreshList");
          })
          .catch((err) => {
            this.formErrors = err.data;
          });
      }
    },

    resetForm() {
      this.$refs.driverForm.reset();
      this.$refs.driverForm.resetValidation();
    },
  },
};
</script>

<style>
</style>